routerConfig.$inject = [
  '$stateProvider',
  '$urlRouterProvider',
  '$locationProvider',
  '$httpProvider',
  'APP'
];

export function routerConfig($stateProvider, $urlRouterProvider, $locationProvider,
  $httpProvider, APP) {

  $stateProvider
    .state({
      abstract: true,
      name: 'app',
      url: '',
      views: {
        '': {
          template: '<app></app>'
        }
      }
    });
   $urlRouterProvider.otherwise(function($injector, $location) {
        var params = $location.path();
        // return  "/"+params;
        return "";
    });

  $locationProvider.html5Mode({
    enabled: true,
    requireBase: false
  });
  $httpProvider.interceptors.push('authInterceptor');
}



// WEBPACK FOOTER //
// ./src/router.js